const $ = (selector) => document.querySelector(selector);
const $$ = (selector) => document.querySelectorAll(selector);
let mobile = window.innerWidth;
let siteUrl = window.location.origin;


/*--------------------------------------------------------------------------------
# START JS CUSTOM HOME PAGE ||||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

const allImgs = $$('img')

if(allImgs){
    allImgs.forEach((img)=>{
        img.classList.add('no-select')
    })
}

if(document.body.classList.contains('index-custom')){

    const sectionInstagram = $('section#shopify-section-sections--18887207747651__17736896558fcd8dd8')
    if(sectionInstagram){
        sectionInstagram.classList.add('not')
    }

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const bannerContent = $$('.slideshow__slide .banner__content'); 

        if (bannerContent) {
            bannerContent.forEach((item, i) => {
                if (mobile > 1200 && i == 0) {item.style.padding = '0';}
                if (mobile > 1200 && i == 3) {item.style.padding = '60px 0 0 0';}
                if (mobile > 1200 && i == 4) {item.style.padding = '60px 0 0 0';}
                item.querySelector('.banner__box').style.maxWidth = "600px";
                item.querySelector('.banner__buttons').style.maxWidth = "100%";
                item.classList.add(`banner__content-${i}`);

                item.querySelector('h2').classList.add('carter-sans')
                if(item.querySelector('.banner__text.rte p')){
                        item.querySelector('.banner__text.rte p')
                }

            });
        }

        const slideshow = $('.slideshow.banner')

       if(slideshow){
            if(mobile>992 && mobile<1800){slideshow.classList.replace('banner--large','banner--medium')}                        
       }

            const btnPrev = $$('button.slider-button.slider-button--prev')[0];
            const btnNext = $$('button.slider-button.slider-button--next')[0];

            document.addEventListener('keydown', (e) => {

                if (e.key === 'ArrowRight' && btnNext) {
                    btnNext.click();
                } 
                
                else if (e.key === 'ArrowLeft' && btnPrev) {
                    btnPrev.click();
                }

            });
    

    function backgroundLoopFade(seletor) {

        const elementos = document.querySelectorAll(seletor);
        if (!elementos.length) return;

        // ===== CONFIGURAÇÕES =====
        const tempoTroca = 5000; // tempo entre trocas (ms)
        const tempoFade  = 800;  // duração do fade (ms)

        const arrayImages = [
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/royal_red_orient_2eb14603-1491-427c-909b-ddd69d88a911.png?v=1778593849',
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/arabic_strong_arabic_silver_3f67ff44-e1ae-4b4e-a32e-736d209f88d7.png?v=1778593849',
            'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/oud_girl_41758cd3-f90a-4630-81b2-080beb90ad52.png?v=1778593849'
        
        ];
        // ========================

        let index = 0;

        elementos.forEach(el => {
            el.style.backgroundSize = 'contain';
            el.style.backgroundPosition = 'center';
            el.style.backgroundRepeat = 'no-repeat';
            el.style.transition = `opacity ${tempoFade}ms ease`;
            mobile<768 ? el.style.height = '50vh' : el.style.height = 'calc(50vh + 250px)'
        });

        function trocarImagem() {

            elementos.forEach(el => {

                el.style.opacity = '0';

                setTimeout(() => {

                    el.style.backgroundImage = `url("${arrayImages[index]}")`;
                    el.style.opacity = '1';

                }, tempoFade);

            });

            // avança índice usando módulo (loop infinito)
            index = (index + 1) % arrayImages.length;

        }

        // primeira imagem imediata
        trocarImagem();

        // loop infinito
        setInterval(trocarImagem, tempoTroca);

    }


    function backgroundLoopFadeText(seletorImg, seletorTexto, indexSection) {

    const elementos = document.querySelectorAll(seletorImg);
    const textos = document.querySelectorAll(seletorTexto);

    if (!elementos.length) return;

    // ===== CONFIGURAÇÕES =====
    const tempoTroca = 5000; // tempo entre trocas
    const tempoFade  = 800;  // duração do fade
    let arrayImages = []
    let arrayTextos = []

    if(indexSection == 0){
        arrayImages = [
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/blossom_blis_banner.png?v=1778612198',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/arabian_elixir_land_a0e33a3e-ab20-4bd5-a5b7-dc092a6991ed.jpg?v=1778612198',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/banner_nner.png?v=1778615425'
        ];

         arrayTextos = [
        `ㅤ<br>ㅤ`,
        `ㅤㅤ<br>ㅤㅤ`,
        `ㅤㅤㅤ<br>ㅤㅤㅤ`
    ];
    }
    if(indexSection == 1){
        arrayImages = [
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/tobacco_oud_purewa_banner_b896f81c-d654-4dbe-bffb-76fa301b71ef.png?v=1778681496',
        'https://cdn.shopify.com/s/files/1/0673/0770/0291/files/blossom_bliss_c_2a140cef-fbd6-43a2-9859-3461d2be791d.jpg?v=1778608248'
        ];

         arrayTextos = [
        `<span class="content-left-benner-media">ㅤㅤㅤㅤㅤ <br> ㅤㅤㅤㅤ</span>`,
        `<span class="content-top-benner-media"ㅤㅤㅤㅤㅤ</span>`,
    ];
    }

   
    // ========================

    let index = 0;

    elementos.forEach(el => {
        mobile<768 ? el.style.backgroundSize = 'auto 100%' : el.style.backgroundSize = 'cover';
        mobile<768 ? el.style.backgroundPosition = '70% 100%' : el.style.backgroundPosition = 'center';       
        el.style.backgroundRepeat = 'no-repeat';
        el.style.transition = `opacity ${tempoFade}ms ease`;
    });

    textos.forEach(el => {
        el.style.transition = `opacity ${tempoFade}ms ease`;
        el.classList.add('carter-sans');
        el.classList.add('text-white');
        mobile< 768 ? el.classList.add('fs-4') : el.classList.add('fs-1');
        el.style.cssText = `text-shadow: 0px 0px 10px rgba(0,0,0,0.5);`;
    });

    function trocar() {

        elementos.forEach(el => el.style.opacity = '0');
        textos.forEach(el => el.style.opacity = '0' );

        setTimeout(() => {

            elementos.forEach(el => {
                el.style.backgroundImage = `url("${arrayImages[index]}")`;
                el.style.opacity = '1';
            });

            textos.forEach(el => {
                el.innerHTML = arrayTextos[index];
                el.style.opacity = '1';
            });

        }, tempoFade);

        index = (index + 1) % arrayImages.length;

    }

    trocar();
    setInterval(trocar, tempoTroca);

    }
    

    const allBannerImages = document.querySelectorAll('div#Banner-template--18887207288899__image_banner_7XDTaA, div#Banner-template--18887207288899__image_banner_GerqTG')
    allBannerImages.forEach((banner,i)=>{

        if(mobile<768){
            banner.classList.contains('banner--large') ? banner.classList.replace('banner--large','banner--medium') : null ;
            banner.querySelector('.banner__content').style.cssText = `
                flex-direction: column;
                justify-content: end;
            `
        }
    })

        const productCardInfoFull = document.querySelectorAll('.fullCollectionSwiper .product-card-custom')

        if(productCardInfoFull){
            productCardInfoFull.forEach((card)=>{
                if(card.classList.contains('d-grid')){card.classList.remove('d-grid')}
            })
        }

        const rfTitle = document.querySelector('.rf__title span')

        if(rfTitle){rfTitle.classList.add('carter-sans','fs-4','text-uppercase')}


        document.addEventListener('DOMContentLoaded',()=>{
                    setTimeout(()=>{
                        const wishlistheroContainer = document.querySelector('div#wishlisthero-floating-launcher-container')

                        if(wishlistheroContainer){
                                wishlistheroContainer.style.cssText = `
                                    opacity: 1;                            
                                `
                            wishlistheroContainer.querySelector('div').style.top = '50%';
                            wishlistheroContainer.querySelector('div').style.transform = 'translateY(-50%)'
                            wishlistheroContainer.querySelector('div').style.right = '20px';
                            wishlistheroContainer.querySelector('div').style.maxHeight = '42px';
                        }                        
                        
                    },500)
        
                })

}

if( document.body.classList.contains('product-produtos-purewa-custom') ||
    document.body.classList.contains('product-layers-kits-custom')){

    const quantity = document.querySelector('.quantity_square')

    if(quantity){
        quantity.classList.replace('quantity_square','quantity')
    }

    const buyButton = document.querySelector('.buy-button-card')
    const buttonCart = document.querySelector('.product-form__submit')

   if(buyButton){
        buyButton.addEventListener('click',()=>{
            buttonCart.click()
        })
   }

    const controle = 0; // começa a aplicar a partir do índice 3

        const containers = document.querySelectorAll('.container');

        function updatePadding() {
            containers.forEach((container, indice) => {
                if (indice > controle && window.innerWidth < 768) {
                    container.classList.add('p-0');
                } else {
                    container.classList.remove('p-0');
                }
            });
        }

        updatePadding();
        window.addEventListener('resize', updatePadding);
    
}

if(
    document.body.classList.contains('product-custom') ||
    document.body.classList.contains('product-produtos-purewa-custom')){

        console.log('product-produtos-purewa-custom')

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const containerReviewApp = document.querySelector('section#shopify-section-template--18887207452739__177437767235bdd677 .scroll-trigger')

    document.addEventListener('DOMContentLoaded', ()=>{
        if(containerReviewApp){
            console.log(containerReviewApp)
            containerReviewApp ? containerReviewApp.classList.replace('page-width','container') : null
        }
    })


    const cartesSans = $$('.carter-sans, .rich-title__caption')

    if(cartesSans){
        cartesSans.forEach((carter)=>{
               if(carter.classList.contains('text-start') && mobile<768){
                    carter.classList.replace('text-start','text-center')
               }
        })
    }

}

if(document.body.classList.contains('collection-custom') ||
   document.body.classList.contains('collection-masculino-feminino-custom')){

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.margin = "0";
            }
        });
    }

    const bannerLarge = $('div#Banner-template--18887207223363__image_banner_YBxHG3')

    if(bannerLarge){
        if(mobile>992 && mobile<1800){
            bannerLarge.classList.replace('banner--large','banner--medium')
        }

        bannerLarge.querySelector('h2.banner__heading.inline-richtext.h2').innerHTML = `
        Crie seu cheiro. Crie sua vibe.<br>
        Camadas que revelam quem você é.
        `

        bannerLarge.querySelector('h2.banner__heading.inline-richtext.h2').style.cssText = `
        opacity: 1;
        `
    }
}

if(
    document.body.classList.contains('page-perfumes-custom') ||
    document.body.classList.contains('page-edicoes-especiais-custom') ||
    document.body.classList.contains('page-mais-desejados-custom') ||
    document.body.classList.contains('page-body-mists-custom') ||
    document.body.classList.contains('page-kits-e-experiencias-custom') ||
    document.body.classList.contains('page-sobre-nos-custom') ||
    document.body.classList.contains('page-politica-de-privacidade-custom') ||
    document.body.classList.contains('page-termos-de-uso-custom') ||
    document.body.classList.contains('page-programa-de-recompensas-custom') ||
    document.body.classList.contains('page-perguntas-frequentes-custom') || 
    document.body.classList.contains('page-perguntas-frequentes-custom') || 
    document.body.classList.contains('page-devolucoes-e-envios-custom')  
  ){

    const section = $$('section')

    if(section){
        section.forEach(s => {
            if(!s.classList.contains('not')){
                s.style.marginTop = "0";
            }
        });
    }
}

if(document.body.classList.contains('page-body-mists-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')
    
    mobile>992 ? bannerSubTitle.innerHTML = `Estilo que<br> deixa marca.` : null
    
}

if(document.body.classList.contains('page-edicoes-especiais-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerTitle.innerHTML = `Criadas para quem não<br> aceita o comum` : null
}

if(document.body.classList.contains('page-mais-desejados-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerSubTitle.innerHTML = `Presença que não<br> passa despercebida` : null
}

if(document.body.classList.contains('page-kits-e-experiencias-custom')){

    const bannerSubTitle = $('.banner-subtitle')
    const bannerTitle = $('.banner-title')

    mobile>992 ?  bannerSubTitle.innerHTML = `Personalidade<br> que marca` : null
}

if(
    document.body.classList.contains('page-sobre-nos-custom') ||
    document.body.classList.contains('page-politica-de-privacidade-custom') ||
    document.body.classList.contains('page-termos-de-uso-custom') ||
    document.body.classList.contains('page-programa-de-recompensas-custom') 
    ){
    $('section#shopify-section-sections--18887207747651__custom_liquid_yVmWNH') ?
    $('section#shopify-section-sections--18887207747651__custom_liquid_yVmWNH').style.display = 'none' :
    null
}

if (document.body.classList.contains('article-post-blog-purewa-custom')) {

    const articleCard = document.querySelectorAll('.article-editorial-template__card');

    articleCard.forEach((card, index) => {
        card.style.order = `${articleCard.length - index}`
    });

}


/*--------------------------------------------------------------------------------
# FOOTER JS CUSTOM ALL STORE |||||||||||||||||||||||||||||||||||||||||||||||||||||
--------------------------------------------------------------------------------*/

// Padronizar Altura de titulos

(function () {
    'use strict';

    var registry = [];
    var rafId = null;

    /**
     * Iguala a altura dos elementos de um seletor.
     * @param {string} selector
     * @param {string|null} groupSelector - se informado, calcula por grupo (ex.: cada carrossel)
     */
    function equalizeHeights(selector, groupSelector) {
        if (!selector) return;

        if (groupSelector) {
            var groups = document.querySelectorAll(groupSelector);
            if (!groups.length) return;
            groups.forEach(function (group) {
                apply(group.querySelectorAll(selector));
            });
            return;
        }

        apply(document.querySelectorAll(selector));
    }

    function apply(elements) {
        if (!elements || !elements.length) return;

        // 1. Reset (write)
        elements.forEach(function (el) {
            el.style.height = 'auto';
        });

        // 2. Medição (read)
        var maxHeight = 0;
        elements.forEach(function (el) {
            var h = el.getBoundingClientRect().height;
            if (h > maxHeight) maxHeight = h;
        });

        if (!maxHeight) return;

        // 3. Aplicação (write)
        var value = Math.ceil(maxHeight) + 'px';
        elements.forEach(function (el) {
            el.style.height = value;
        });
    }

    function refresh() {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(function () {
            registry.forEach(function (item) {
                equalizeHeights(item.selector, item.group);
            });
            rafId = null;
        });
    }

    function register(selector, groupSelector) {
        if (!selector) return;

        var exists = registry.some(function (item) {
            return item.selector === selector && item.group === (groupSelector || null);
        });
        if (exists) return;

        registry.push({ selector: selector, group: groupSelector || null });
        refresh();
    }

    function init() {
        refresh();

        // Recalcula quando imagens/fontes terminarem de carregar
        window.addEventListener('load', refresh);
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(refresh);
        }

        window.addEventListener('resize', refresh);
        window.addEventListener('orientationchange', refresh);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // API global
    window.EqualizeHeights = {
        register: register,
        refresh: refresh,
        run: equalizeHeights
    };
})();

// Altura única para todos os títulos da página
EqualizeHeights.register('.swiper-slide .product-card__title');

// Ou calculando por carrossel (recomendado se houver mais de um)
EqualizeHeights.register('.product-card__title', '.swiper');

// Depois de renderizar conteúdo via AJAX ou de inicializar o Swiper com loop
EqualizeHeights.refresh();



function highlightText(selector, words) {
  const elements = document.querySelectorAll(selector);

  // escapa palavras
  const escapedWords = words.map(word =>
    word.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
  );

  // regex única
  const regex = new RegExp(`(${escapedWords.join('|')})`, 'gi');

  elements.forEach(el => {
    const text = el.textContent;

    // controle de palavras já usadas
    const used = new Set();

    const newHTML = text.replace(regex, (match) => {
      const key = match.toLowerCase();

      if (!used.has(key)) {
        used.add(key);
        return `<strong>${match}</strong>`;
      }

      return match; // mantém as próximas ocorrências sem alterar
    });

    el.innerHTML = newHTML;
  });
}

highlightText('.sn-highlight-paragraph', [
  'sobre',
  'sentir',
  'viver',
  'marcar',
  'presença',
  'você',
  'lembrado',
]);

const oldFooterBlockNewsLetter = $('.old__footer-block__newsletter')

oldFooterBlockNewsLetter ? oldFooterBlockNewsLetter.remove() : null

const footerBlock = $$('footer .footer-block')
const footerBlockNews = $('.footer-block__newsletter')
const footerCopyright = $('.footer__copyright.caption')

const footerContentTop = document.querySelector('.footer__content-top')
const footerPayment = document.querySelector('.footer__payment')

const footerContentBottom = document.querySelectorAll('.footer__content-bottom-wrapper')

if(footerContentBottom){    

    footerContentBottom[0].style.order = '2'
    footerContentBottom[1].style.cssText = `
        order: 1;
        display: flex;
        justify-content: space-between;
    `

    const socialIcons = document.createElement('div');

    socialIcons.innerHTML = `
        <div style="display:flex; align-items:center; gap:16px; padding:12px 0;">

                <a href="https://www.instagram.com/purewacosmeticos" target="_blank" rel="noopener" aria-label="Instagram">
                <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 11C3 7.22876 3 5.34315 4.17157 4.17157C5.34315 3 7.22876 3 11 3H13C16.7712 3 18.6569 3 19.8284 4.17157C21 5.34315 21 7.22876 21 11V13C21 16.7712 21 18.6569 19.8284 19.8284C18.6569 21 16.7712 21 13 21H11C7.22876 21 5.34315 21 4.17157 19.8284C3 18.6569 3 16.7712 3 13V11Z" stroke="#000000" stroke-width="2"/>
                    <circle cx="16.5" cy="7.5" r="1.5" fill="#000000"/>
                    <circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2"/>
                </svg>
                </a>

                <a href="https://www.facebook.com/share/189DPWwau8/" target="_blank" rel="noopener" aria-label="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="24px" height="24px" fill="black">
                    <path d="M25,3C12.85,3,3,12.85,3,25c0,11.03,8.125,20.137,18.712,21.728V30.831h-5.443v-5.783h5.443v-3.848c0-6.371,3.104-9.168,8.399-9.168c2.536,0,3.877,0.188,4.512,0.274v5.048h-3.612c-2.248,0-3.033,2.131-3.033,4.533v3.161h6.588l-0.894,5.783h-5.694v15.944C38.716,45.318,47,36.137,47,25C47,12.85,37.15,3,25,3z"/>
                </svg>
                </a>

                <a href="https://www.tiktok.com/@purewacosmeticos?" target="_blank" rel="noopener" aria-label="TikTok">
                <svg fill="#000000" width="22px" height="22px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"/>
                </svg>
                </a>

                <a href="https://www.youtube.com/@PurewaCosmeticos" class="d-none" target="_blank" rel="noopener" aria-label="YouTube">
                <svg width="24px" height="24px" viewBox="0 -3 20 20" xmlns="http://www.w3.org/2000/svg" fill="#000000">
                    <g transform="translate(-244,-7279)">
                    <path d="M251.988432,7291.58588 L251.988432,7285.97425 C253.980638,7286.91168 255.523602,7287.8172 257.348463,7288.79353 C255.843351,7289.62824 253.980638,7290.56468 251.988432,7291.58588 M263.090998,7283.18289 C262.747343,7282.73013 262.161634,7282.37809 261.538073,7282.26141 C259.705243,7281.91336 248.270974,7281.91237 246.439141,7282.26141 C245.939097,7282.35515 245.493839,7282.58153 245.111335,7282.93357 C243.49964,7284.42947 244.004664,7292.45151 244.393145,7293.75096 C244.556505,7294.31342 244.767679,7294.71931 245.033639,7294.98558 C245.376298,7295.33761 245.845463,7295.57995 246.384355,7295.68865 C247.893451,7296.0008 255.668037,7296.17532 261.506198,7295.73552 C262.044094,7295.64178 262.520231,7295.39147 262.895762,7295.02447 C264.385932,7293.53455 264.28433,7285.06174 263.090998,7283.18289"/>
                    </g>
                </svg>
                </a>

        </div>
    `

    footerContentBottom[1].appendChild(socialIcons);
}


if(footerPayment){
    footerPayment.querySelector('ul').style.display = 'none';

    footerPayment.innerHTML = `
        <div class="payment-methods">
            <img src="https://icons.yampi.me/svg/card-amex.svg" alt="American Express" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-visa.svg" alt="Visa" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-diners.svg" alt="Diners Club" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-mastercard.svg" alt="Mastercard" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-discover.svg" alt="Discover" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-aura.svg" alt="Aura" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-elo.svg" alt="Elo" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-billet.svg" alt="Boleto Bancário" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-hiper.svg" alt="Hiper" width="39" height="26" loading="lazy">
            <img src="https://icons.yampi.me/svg/card-pix.svg" alt="Pix" width="39" height="26" loading="lazy">
        </div>
    `
}

if(footerContentTop){
    footerContentTop.classList.replace('page-width','container-fluid');

    if(window.innerWidth>992){
        footerContentTop.style.margin = '20px 0 30px 0'
    }else{
        footerContentTop.style.margin = '20px 0 100px 0'
    }
}

if(footerBlock){

    console.log('footer')

    footerBlock.forEach((block) =>{

        if(block.querySelector('h2.footer-block__heading').textContent.trim() === 'Purewa'){

            block.querySelector('h2.footer-block__heading').style.display = 'none';

            const ul = block.querySelector('ul')

            ul.addEventListener('click',()=>{
                window.location.href = "https://purewa.com.br/"
            })

            ul.style.cssText = `
                cursor: pointer;
                ${ mobile<992 ? 'display: grid; justify-content: center;' : null }
            `

            ul.innerHTML = `
            <li>
                <picture>
                    <source 
                    srcset="//cdn.shopify.com/s/files/1/0673/0770/0291/files/Logo_Purewa_alta.webp?v=1773694088" 
                    type="image/webp">
                    <img 
                        src="//cdn.shopify.com/s/files/1/0673/0770/0291/files/Logo_Purewa_alta_footer.png?v=1773694057"
                        alt="Purewa"
                        class="img-fluid"
                        loading="lazy"
                        width="180"
                        height=""
                        style="object-fit: contain;
                                max-width: 157px;"
                    >
                </picture>
            </li>
            <li>Presença que fica.</li>
            `
        }

        if(footerBlockNews && footerBlockNews.querySelector('label.field__label')){
            if(footerBlockNews.querySelector('label.field__label').textContent.trim() === 'E-mail'){
                footerBlockNews.querySelector('label.field__label').textContent = 'ENDEREÇO DE EMAIL';
            }

            $('.newsletter-form__button.field__button').innerHTML = `INSCREVER-SE`
        }
    })
}

if(footerCopyright){

    footerCopyright.style.textAlign = 'left';

    footerCopyright.innerHTML = `
         PUREWA COSMÉTICOS<br><br>
        Alameda Yayá, 814 - Sala 01A - Jd. Aida - Guarulhos - SP<br>
        SÃO PAULO - CEP: 07060-000 / CNPJ: 43.640.155/0001-03
    `
}